const en = {
  nav: {
    home: 'HOME',
    california: 'CALIFORNIA',
    texas: 'TEXAS',
    florida: 'FLORIDA',
    menu: 'MENU',
    faq: 'FAQ',
    freeEstimate: 'Free Estimate',
    bookNow: 'BOOK NOW',
    myBooking: 'My Booking',
  },
  seo: {
    homeDescription:
      'Top Rated Hibachi At Home Experience. We bring our Hibachi Grill + Chef to your backyard in California, Texas, and Florida.',
  },
  hero: {
    title: 'FAMILY FRIENDS HIBACHI',
    tagline: '#1 Rated Hibachi At Home',
    subtitle: 'Experience authentic Japanese hibachi cooking at your home',
    description:
      'Professional chefs bring the excitement of hibachi-style cooking directly to your backyard.',
    bookNow: 'Book Now',
    freeEstimate: 'Free Estimate',
    slogan: '#MORESAKEMOREHAPPY',
    trustIndicators: 'No hidden fees \u2022 500+ events \u2022 5-star rated',
    slides: {
      heroBg: 'Hibachi grilling in action',
      chefCooking: 'Professional chef performing hibachi cooking',
      food1: 'Freshly grilled hibachi steak and vegetables',
      food2: 'Grilled shrimp hibachi style',
      gallery1: 'Outdoor hibachi party setup',
      gallery2: 'Beautiful hibachi food presentation',
      gallery3: 'Guests enjoying hibachi at home',
    },
    quickQuote: {
      guests: 'Guest count',
      date: 'Event date',
      region: 'Select area',
      submit: 'Get Free Quote',
    },
    stats: {
      events: 'Events Served',
      cities: 'Cities Covered',
      rating: 'Star Rating',
    },
  },
  menuPage: {
    description:
      'View our hibachi catering menu with proteins, premium upgrades, and add-ons. Starting at $60 per person.',
  },
  galleryPage: {
    description:
      'Browse photos from our hibachi at home events. See our chefs in action at backyard parties, corporate events, and celebrations.',
  },
  faqPage: {
    description:
      'Frequently asked questions about our hibachi at home catering service. Pricing, setup, dietary accommodations, and booking info.',
  },
  contactPage: {
    description:
      'Contact Family Friends Hibachi for your at-home hibachi catering needs. Serving California, Texas, and Florida.',
  },
  howItWorks: {
    title: 'How It Works',
    subtitle: 'Simple steps to your perfect hibachi party',
    step1: { title: 'Book Online', description: 'Choose your date, time, and menu preferences' },
    step2: { title: 'We Prepare', description: 'Our team handles all ingredients and equipment' },
    step3: {
      title: 'Enjoy the Show',
      description: 'Watch our chef perform and enjoy delicious food',
    },
    step4: { title: 'We Clean Up', description: 'Relax while we handle all the cleanup' },
    trustBar: {
      insured: 'Fully Insured Chefs',
      licensed: 'Licensed & Certified',
      fiveStarRated: '5-Star Rated',
      eventsServed: '500+ Events Served',
    },
    valueProps: {
      noTravel: 'No Travel Fees within 50 Miles',
      freeSetup: 'Free Table & Chair Setup',
      weekdayDiscount: '10% OFF Weekday Parties',
      insuredChefs: 'Professional & Insured Chefs',
    },
  },
  menu: {
    title: 'Pricing & Service',
    subtitle: 'Fresh ingredients, authentic flavors',
    proteins: 'Proteins',
    sides: 'Sides & Appetizers',
    chicken: 'Chicken',
    steak: 'Filet Mignon',
    shrimp: 'Shrimp',
    salmon: 'Salmon',
    lobster: 'Lobster Tail',
    tofu: 'Tofu (Vegetarian)',
    friedRice: 'Hibachi Fried Rice',
    noodles: 'Yakisoba Noodles',
    vegetables: 'Grilled Vegetables',
    salad: 'Ginger Salad',
    soup: 'Miso Soup',
    edamame: 'Edamame',
    includes: {
      salad: 'Fresh Salad',
      rice: 'Fried Rice',
      vegetables: 'Hibachi Vegetables',
      show: 'Game & Show',
    },
    protein: {
      title: 'Protein Choices',
      included: 'Included',
      select: 'Select',
      selected: 'Selected',
    },
    upgrades: {
      title: 'Premium Upgrades',
      filet: 'Filet Mignon',
      lobster: 'Lobster',
      ribeye: 'Premium Ribeye',
      shrimp: 'Jumbo Shrimp',
      salmon: 'Wild Salmon',
      scallops: 'Large Scallops',
    },
    addons: {
      title: 'Add-ons',
      gyoza: 'Gyoza (12pcs)',
      edamame: 'Edamame',
      noodles: 'Noodles',
      thirdProtein: '3rd Protein',
    },
    coupon: {
      title: 'Special Coupons',
      subtitle: 'Sunday to Friday parties only!',
      email: 'Email us at',
    },
    note: {
      outdoor: 'We cook outside only.',
      weather:
        'We provide services rain or shine, as long as there is a dry area for the chef to cook under.',
    },
    choosePackage: 'Choose Your Package',
    allMealsInclude:
      'All course meals are served with steamed rice, hibachi vegetables, and our signature sauces.',
    signatureDishes: 'Signature Dishes',
    perPerson: 'per person',
    popular: 'Most Popular',
    addToOrder: 'Add to Order',
    removeFromOrder: 'Remove',
    viewOrder: 'View Order',
    orderSummary: 'Your Order',
    goToBooking: 'Proceed to Booking',
    itemsSelected: 'items selected',
    guests: 'guests',
    loadError: 'Menu data could not be loaded. Please try again later.',
    emptyOrder: 'No items selected yet',
    selected: 'Selected',
    selectPackage: 'Select',
    package: 'Package',
    admin: {
      title: 'Menu Management',
      addItem: 'Add Menu Item',
      editItem: 'Edit Menu Item',
      packages: 'Packages',
      categories: 'Categories',
      items: 'Menu Items',
      spotlight: 'Spotlight',
      pricing: 'Pricing',
      resetDefault: 'Reset to Default',
      translationHint: 'Leave empty to show English',
      saveSuccess: 'Menu updated successfully',
    },
  },
  pricing: {
    title: 'Pricing',
    subtitle: 'Transparent pricing with no hidden fees',
    perPerson: 'person',
    total: 'total',
    minimum: 'minimum for all parties',
    startingFrom: 'Starting from ${{price}}/person',
    kids: 'per child 12 and under',
    includes: 'Includes',
    includesList: {
      chef: 'Professional hibachi chef',
      ingredients: 'All ingredients and supplies',
      equipment: 'Hibachi grill and equipment',
      setup: 'Setup and cleanup',
      show: 'Live cooking entertainment',
    },
    basic: { title: 'Basic Package', description: 'Perfect for intimate gatherings' },
    premium: { title: 'Premium Package', description: 'Complete hibachi experience' },
    deluxe: { title: 'Deluxe Package', description: 'Ultimate luxury dining' },
  },
  calendar: {
    available: 'Available',
    limited: 'Limited',
    busy: 'Busy',
    unavailable: 'Unavailable',
    today: 'Today',
    goToToday: 'Go to today',
    prevMonth: 'Previous month',
    nextMonth: 'Next month',
    weekdays: {
      sun: 'Sun',
      mon: 'Mon',
      tue: 'Tue',
      wed: 'Wed',
      thu: 'Thu',
      fri: 'Fri',
      sat: 'Sat',
    },
    months: {
      january: 'January',
      february: 'February',
      march: 'March',
      april: 'April',
      may: 'May',
      june: 'June',
      july: 'July',
      august: 'August',
      september: 'September',
      october: 'October',
      november: 'November',
      december: 'December',
    },
    loadError: 'Unable to load calendar data. Please try again.',
    loading: 'Loading calendar...',
    retry: 'Retry',
  },
  slider: {
    chef: 'Professional Hibachi Chef in Action',
    steak: 'Delicious Hibachi Steak',
    shrimp: 'Amazing Hibachi Shrimp',
    setup: 'Premium Hibachi Setup',
    presentation: 'Beautiful Food Presentation',
  },
  booking: {
    title: 'Book Your Event',
    subtitle: 'Select your region to get started',
    selectRegion: 'Select your region to get started',
    california: 'California',
    texas: 'Texas',
    florida: 'Florida',
    californiaTagline: 'Professional hibachi at your doorstep',
    texasTagline: 'Bringing hibachi excellence to Texas',
    floridaTagline: 'Sunshine state hibachi experience',
    servingAreas: 'Areas We Serve',
    bookIn: 'Book Now',
    note: '* No payment required. We will contact you to confirm.',
    quickBook: 'Quick Book:',
    summary: 'Booking Details',
    addToCalendar: 'Add to Calendar',
    googleCalendar: 'Google Calendar',
    outlook: 'Outlook',
    appleICal: 'Apple / iCal',
  },
  gallery: {
    title: 'Gallery',
    subtitle: 'Experience the Family Friends Hibachi difference',
    items: {
      chef: 'Professional Hibachi Chef',
      chefDesc: 'Professional Hibachi Chef in Action',
      grill: 'Hibachi Grill Setup',
      grillDesc: 'Premium Hibachi Grill Setup',
      steak: 'Hibachi Steak',
      steakDesc: 'Delicious Hibachi Steak',
      vegetables: 'Hibachi Vegetables',
      vegetablesDesc: 'Fresh Hibachi Vegetables',
      shrimp: 'Hibachi Shrimp',
      shrimpDesc: 'Amazing Hibachi Shrimp',
      food: 'Food Presentation',
      foodDesc: 'Beautiful Food Presentation',
    },
  },
  calculator: {
    title: 'Price Calculator',
    subtitle: 'Get an instant estimate for your event',
    guests: 'Number of Guests',
    adults: 'Adults',
    kids: 'Kids (10 & under)',
    upgrades: 'Optional Upgrades',
    summary: 'Price Summary',
    subtotal: 'Subtotal',
    discount: 'Group Discount',
    minimum: 'Minimum Order',
    total: 'Total',
    gratuity: 'Suggested Gratuity',
    grandTotal: 'Grand Total',
    bookNow: 'Book Your Event',
    note: '* Travel fees may apply based on location. Final price confirmed at booking.',
    minimumNotice: 'Minimum 10 guests required',
    thirdProtein: '3rd Protein',
    noodles: 'Noodles',
  },
  reviews: {
    title: 'Customer Reviews',
    subtitle: 'See what our customers are saying about their Family Friends Hibachi experience',
    bookNow: 'Book Your Event',
    ctaTitle: 'Ready to Create Your Own Amazing Experience?',
    ctaText: 'Join hundreds of satisfied customers',
    rating: '5.0 Average Rating',
    verified: '100+ Verified Reviews',
    topRated: 'Top Rated Service',
    items: {
      r1: {
        location: 'Los Angeles, CA',
        review:
          'Amazing experience! The chef was entertaining and the food was incredible. Our backyard party was a huge success!',
      },
      r2: {
        location: 'Houston, TX',
        review:
          'Professional service from start to finish. The hibachi setup was perfect and the food was restaurant quality.',
      },
      r3: {
        location: 'Miami, FL',
        review:
          'Best decision for our anniversary! The intimate hibachi experience was romantic and delicious.',
      },
      r4: {
        location: 'San Diego, CA',
        review:
          "Outstanding value for money. The chef's performance was spectacular and the food was fresh and flavorful.",
      },
      r5: {
        location: 'Austin, TX',
        review:
          "The best hibachi experience we've ever had! Fresh ingredients, amazing flavors, and the chef's entertainment skills were top-notch.",
      },
      r6: {
        location: 'Orlando, FL',
        review:
          'Incredible value for money. The food was restaurant-quality and the service was impeccable. Our guests are still talking about it!',
      },
      r7: {
        location: 'San Francisco, CA',
        review:
          'We hosted a 30-person team building event and it was flawless. The onion volcano trick had everyone cheering! Highly recommend for corporate gatherings.',
      },
      r8: {
        location: 'Dallas, TX',
        review:
          'Great food and entertainment. The chef was very skilled and personable. Only minor note — book early because weekends fill up fast!',
      },
      r9: {
        location: 'Fort Lauderdale, FL',
        review:
          'Our kids absolutely loved it! The chef made it so interactive and fun. The food was fresh, delicious, and cooked right before our eyes.',
      },
      r10: {
        location: 'Sacramento, CA',
        review:
          'Perfect for our wedding rehearsal dinner. Guests loved the interactive experience and the sake was flowing! Would use again for our anniversary.',
      },
    },
  },
  instagram: {
    title: 'Follow Our Journey',
    followUs: 'FOLLOW US ON INSTAGRAM',
  },
  referral: {
    title: 'Refer Friends, Earn Rewards',
    subtitle: 'Share the hibachi love and get rewarded!',
    step1Title: 'Share Your Code',
    step1Desc: 'Share your unique referral code with friends and family',
    step2Title: 'Friend Books',
    step2Desc: 'Your friend gets $30 off their first booking',
    step3Title: 'You Get Rewarded',
    step3Desc: 'Earn $50 credit for your next event',
    yourReward: 'Your Reward',
    friendDiscount: "Friend's Discount",
    getCode: 'Get Your Referral Code',
    emailPlaceholder: 'Enter your email',
    invalidEmail: 'Please enter a valid email',
    getCodeBtn: 'Get Code',
    successTitle: 'Your Referral Code is Ready!',
    successDesc: 'Check your email for your unique referral code and instructions.',
    terms:
      '* Rewards apply after your friend completes their first booking. No limit on referrals!',
    codeApplied: 'Referral code valid! ${{discount}} discount applied.',
    codeInvalid: 'Invalid referral code',
    checkFailed: 'Verification failed',
    copyCode: 'Copy Code',
    copied: 'Copied!',
    shareVia: 'Share via',
    shareMessage:
      'Use my referral code {{code}} to get $30 off your first hibachi at home party! Book at familyfriendshibachi.com',
    shareEmailSubject: '$30 Off Hibachi At Home — My Referral',
  },
  newsletter: {
    title: 'Get Exclusive Offers',
    subtitle: 'Subscribe to our newsletter for special deals and party tips!',
    placeholder: 'Enter your email address',
    subscribe: 'Subscribe',
    invalidEmail: 'Please enter a valid email address',
    success: 'Thank you for subscribing! Check your inbox for exclusive offers.',
    error: 'Something went wrong. Please try again.',
    privacy: 'We respect your privacy. Unsubscribe anytime.',
    benefit1: 'Exclusive discounts',
    benefit2: 'Party planning tips',
    benefit3: 'New menu updates',
  },
  myBooking: {
    title: 'Check My Booking',
    subtitle: 'Enter the email or phone number you used when booking',
    emailPlaceholder: 'Enter your email address',
    phonePlaceholder: 'Enter your phone number',
    search: 'Search Booking',
    searching: 'Searching...',
    results: 'Results',
    noResults: 'No bookings found',
    error: 'Search failed, please try again',
    bookingId: 'Booking ID',
    needHelp: 'Need Help?',
    contactUs: 'If you have any questions, feel free to contact us',
    pendingNote: 'We will contact you within 2 hours to confirm',
    confirmedNote: 'Looking forward to seeing you! Chef will arrive 30 minutes early',
  },
  faq: {
    title: 'FAQ',
    subtitle: 'Everything you need to know',
    q1: 'What areas do you serve?',
    a1: 'We currently serve California, Texas, and Florida. Please contact us to verify if we cover your specific location.',
    q2: 'How many guests can you accommodate?',
    a2: 'We require a minimum of 10 guests and can accommodate up to 50. For larger events, contact us for special arrangements.',
    q3: 'What do I need to provide?',
    a3: 'You just need to provide the space and your guests! We bring all equipment, ingredients, utensils, and handle all setup and cleanup.',
    q4: 'How far in advance should I book?',
    a4: 'We recommend booking at least 2 weeks ahead for weekday events and 3-4 weeks for weekends. Popular dates book up fast!',
    q5: 'Can you accommodate dietary restrictions?',
    a5: 'Yes! We offer vegetarian options and can accommodate most dietary restrictions. Please let us know when booking.',
    q6: 'What is your cancellation policy?',
    a6: 'Full refund if cancelled 7+ days before the event. 50% refund with 3-6 days notice. No refund with less than 3 days notice.',
    q7: 'What if someone does not eat meat?',
    a7: 'We can provide tofu to meet Vegetarian and Vegan needs. The price per person does not change. We will supplement their dishes with additional food such as extra veggies, salad, and noodles.',
    q8: 'Can the customer provide their own proteins?',
    a8: 'Due to insurance and pricing requirements, we do not cook any outside protein or food at this time.',
    q9: 'How can I make a reservation?',
    a9: 'All of our bookings are currently done through our website. If you are going to be 30+ guests, please book two reservations for the same date and time, so we can send two chefs. There are no extra fees for an additional chef.',
    q10: 'What is the cancellation fee?',
    a10: '48 hours notice for all cancellations and rescheduled parties or guest will be charged a fee of $200. If it rains, customer is required to provide some type of covering for the chef to cook under.',
  },
  contact: {
    title: 'Contact Us',
    subtitle: 'Get in touch',
    phone: 'Phone',
    email: 'Email',
    hours: 'Business Hours',
    address: 'Service Areas',
  },
  footer: {
    description: 'Bringing authentic hibachi experience to your home',
    quickLinks: 'Quick Links',
    contact: 'Contact',
    followUs: 'Follow Us',
    copyright: '© 2024 Family Friends Hibachi. All rights reserved.',
    allRightsReserved: 'All Rights Reserved.',
    privacyPolicy: 'Privacy Policy',
    termsOfService: 'Terms of Service',
  },
  menuSelection: {
    title: 'SELECT YOUR DISH TYPE',
    subtitle: 'All meals include steamed rice, hibachi vegetables, and signature sauces',
    mostPopular: 'Most Popular',
    proteinsPerPerson: '{{count}} proteins/person',
    regular: {
      title: 'REGULAR',
      proteins: '2 proteins per person',
      service: 'Show included, 90 min service',
    },
    premium: {
      title: 'PREMIUM',
      proteins: '2 premium proteins: Filet Mignon, Lobster, Scallops',
      service: 'Show included, 120 min service',
      price: '$80',
    },
    catering: {
      title: 'LARGE GATHERING',
      note: '50+ guests buffet style',
      proteins: '2 proteins per person',
      service: 'Shows included, 3-4 hours service',
      price: '$45',
    },
    intimate: {
      title: 'INTIMATE PARTY',
      note: '5-7 guests',
      includes: 'Salads, gyoza, edamame, noodles + mixed proteins',
      substitution: 'Same-price proteins can be substituted',
    },
  },
  form: {
    name: 'Full Name',
    namePlaceholder: 'Enter your full name',
    email: 'Email Address',
    emailPlaceholder: 'your@email.com',
    phone: 'Phone Number',
    phonePlaceholder: '(123) 456-7890',
    date: 'Event Date',
    time: 'Preferred Time',
    timeHint: 'Optional, will be confirmed',
    guests: 'Number of Guests',
    guestsHint: 'Minimum 10 guests',
    region: 'Select Region',
    eventType: 'Event Type',
    message: 'Additional Message',
    messagePlaceholder: 'Tell us about your event...',
    selectOption: 'Select an option',
    selectDate: 'Select date',
    selectTime: 'Please select a time slot',
    nameRequired: 'Please enter your name',
    emailRequired: 'Please enter your email',
    phoneRequired: 'Please enter your phone number',
    submit: 'Submit',
    submitting: 'Submitting...',
    submitReservation: 'Submit Reservation',
    success: 'Booking Submitted!',
    successMessage:
      'Your booking request has been received. We will contact you within 2 hours to confirm.',
    checkEmail: 'Check your email for booking confirmation',
    weWillContact: 'We will contact you shortly to confirm details.',
    error: 'Something went wrong. Please try again.',
    required: 'Required',
    people: 'people',
    noPaymentRequired: '* No payment required now. We will contact you to confirm.',
    invalidEmail: 'Please enter a valid email address',
    invalidPhone: 'Please enter a valid phone number',
    validEmail: 'Valid email',
    validPhone: 'Valid phone',
    selectRegion: 'Select your region',
    eventTypes: {
      birthday: 'Birthday Party',
      anniversary: 'Anniversary',
      graduation: 'Graduation',
      corporate: 'Corporate Event',
      holiday: 'Holiday Party',
      wedding: 'Wedding Event',
      other: 'Other',
    },
    referralSource: 'How did you hear about us?',
    referral: {
      google: 'Google Search',
      friend: 'Friend Referral',
      event: 'Seen at Event',
      other: 'Other',
    },
    couponCode: 'Coupon Code',
    couponPlaceholder: 'Enter coupon code (optional)',
    applyCoupon: 'Apply',
    referralCode: 'Referral Code',
    referralPlaceholder: 'Enter referral code (optional)',
    applyReferral: 'Apply',
    moreOptions: 'Coupon / Referral Code',
    minGuests: 'Minimum 10 guests required',
  },
  estimate: {
    title: 'Get Your Free Estimate',
    subtitle: 'Tell us about your event and we will provide a custom quote',
    benefits: {
      title: 'Why Choose Us?',
      professional: 'Professionally trained chefs',
      fresh: 'Fresh, high-quality ingredients',
      entertainment: 'Live cooking entertainment',
      cleanup: 'Complete setup and cleanup',
      custom: 'Customizable menu options',
    },
  },
  bookNow: {
    title: 'Book Your Hibachi Party',
    subtitle: 'Fill out the form below to reserve your date',
    selectRegion: 'First, select your region',
    formTitle: 'Event Details',
    pricing: 'Pricing from $45/person',
    note: 'We will confirm availability within 2 hours',
  },
  notFound: {
    title: 'Page Not Found',
    description: 'The page you are looking for does not exist.',
    backHome: 'Back to Home',
  },
  common: {
    learnMore: 'Learn More',
    viewAll: 'View All',
    loading: 'Loading...',
    close: 'Close',
    backToHome: 'Back to Home',
    total: 'Total',
    toBeConfirmed: 'To be confirmed',
    specialOffer: 'Special Offer',
    goTo: 'Go to',
    previous: 'Previous',
    next: 'Next',
    previousSlide: 'Previous slide',
    nextSlide: 'Next slide',
    networkError: 'Network error. Please try again or call us directly.',
    errorTitle: 'Something went wrong',
    errorMessage: 'Sorry, an error occurred while loading the page.',
    retry: 'Retry',
    skipToContent: 'Skip to main content',
  },
  topBar: {
    textUs: 'Text Us',
    email: 'Email',
    limitedSlots: 'Limited weekend slots — Book now!',
  },
  photoShare: {
    title: 'Share Your Photos',
    subtitle: 'Post your Family Friends Hibachi experience and get $25 off your next event!',
    option1Title: 'Post on Instagram',
    option1Desc: 'Tag us and use #FamilyFriendsHibachi',
    option2Title: 'Upload Directly',
    option2Desc: 'Share your photos with us',
    dropzone: 'Drag & drop photos here or click to browse',
    maxFiles: 'Up to 5 photos',
    emailPlaceholder: 'Your email (for reward tracking)',
    invalidEmail: 'Please enter a valid email for reward tracking',
    instagramPlaceholder: 'Your Instagram handle (optional)',
    submit: 'Submit Photos',
    submitting: 'Uploading...',
    error: 'Upload failed. Please try again.',
    successTitle: 'Photos Submitted!',
    successDesc: 'Thank you for sharing! Your $25 credit will be applied to your next booking.',
    terms: '* Credit applied after photo review. Photos may be featured on our social media.',
  },
  offer: {
    noTravel: 'No Travel Fees',
    within50: 'Within 50 Miles',
    noHidden: 'No hidden charges',
    exclusive: 'Exclusive discounts',
    freeSetup: 'Free tables & chairs',
    sunFri: 'Sunday to Friday Special!',
  },
  coupon: {
    minGuests: 'Minimum {{count}} guests required',
    applied: 'Coupon applied! Discount: {{discount}}',
    invalid: 'Invalid coupon code',
    checkFailed: 'Verification failed',
    under15: 'under 15 people',
    range15to25: '15-25 people',
    range25to35: '25-35 people',
    over35: '35+ people',
  },
  privacy: {
    title: 'Privacy Policy',
    lastUpdated: 'Last updated: January 2026',
    section1: {
      title: '1. Information We Collect',
      intro: 'When you use Family Friends Hibachi services, we may collect:',
      contact: 'Contact Information',
      contactDesc: 'Name, email address, phone number',
      booking: 'Booking Details',
      bookingDesc: 'Event date, time, location, number of guests',
      payment: 'Payment Information',
      paymentDesc: 'Processed securely through third-party providers',
      usage: 'Usage Data',
      usageDesc: 'How you interact with our website',
    },
    section2: {
      title: '2. How We Use Your Information',
      item1: 'Process and confirm your bookings',
      item2: 'Send booking confirmations and reminders',
      item3: 'Respond to your inquiries',
      item4: 'Improve our services',
      item5: 'Send promotional offers (with your consent)',
    },
    section3: {
      title: '3. Information Sharing',
      intro: 'We do not sell your personal information. We may share information with:',
      item1: 'Service providers who assist in our operations',
      item2: 'Legal authorities when required by law',
    },
    section4: {
      title: '4. Data Security',
      desc: 'We implement appropriate security measures to protect your personal information. However, no internet transmission is 100% secure.',
    },
    section5: {
      title: '5. Your Rights',
      intro: 'You have the right to:',
      item1: 'Access your personal data',
      item2: 'Request correction of inaccurate data',
      item3: 'Request deletion of your data',
      item4: 'Opt-out of marketing communications',
    },
    section6: {
      title: '6. Cookies',
      desc: 'We use cookies to improve your browsing experience and analyze site traffic. You can control cookies through your browser settings.',
    },
    section7: {
      title: '7. Contact Us',
      intro: 'For privacy-related questions:',
    },
  },
  terms: {
    title: 'Terms of Service',
    lastUpdated: 'Last updated: January 2026',
    section1: {
      title: '1. Services',
      desc: 'Family Friends Hibachi provides mobile hibachi catering services. We bring professional chefs and equipment to your location to prepare authentic hibachi meals.',
    },
    section2: {
      title: '2. Booking & Reservations',
      minimum: 'Minimum Guests',
      minimumDesc: '10 guests minimum required',
      confirmation: 'Confirmation',
      confirmationDesc: 'Bookings are confirmed after our team contacts you',
      deposit: 'Deposit',
      depositDesc: 'A deposit may be required to secure your date',
      finalCount: 'Final Count',
      finalCountDesc: 'Guest count must be confirmed 48 hours before the event',
    },
    section3: {
      title: '3. Cancellation Policy',
      sevenDays: '7+ days notice',
      sevenDaysDesc: 'Full refund of deposit',
      threeSixDays: '3-6 days notice',
      threeSixDaysDesc: '50% of deposit refunded',
      lessThanThree: 'Less than 3 days',
      lessThanThreeDesc: 'Deposit is non-refundable',
      weather: 'Weather',
      weatherDesc: 'We will reschedule at no charge for severe weather',
    },
    section4: {
      title: '4. Customer Responsibilities',
      intro: 'Customers must provide:',
      item1: 'Adequate outdoor space for cooking (minimum 10x10 feet)',
      item2: 'Access to electricity (standard outlet within 50 feet)',
      item3: 'Tables and seating for guests',
      item4: 'Weather protection if needed (tent, gazebo, etc.)',
    },
    section5: {
      title: '5. Food Safety & Allergies',
      desc: 'Please inform us of any food allergies or dietary restrictions at the time of booking. While we take precautions, we cannot guarantee a completely allergen-free environment due to the nature of hibachi cooking.',
    },
    section6: {
      title: '6. Liability',
      desc: 'Family Friends Hibachi carries liability insurance. However, customers are responsible for their guests and property. We are not liable for accidents caused by guest behavior or pre-existing property conditions.',
    },
    section7: {
      title: '7. Service Area',
      intro: 'We currently serve:',
      california: 'California (Los Angeles, San Diego, San Francisco, and surrounding areas)',
      texas: 'Texas (Houston, Dallas, Austin, San Antonio, and surrounding areas)',
      florida: 'Florida (Miami, Fort Lauderdale, and surrounding areas)',
      travelFee: 'Travel fees may apply for locations outside our standard service area.',
    },
    section8: {
      title: '8. Changes to Terms',
      desc: 'We reserve the right to modify these terms at any time. Continued use of our services constitutes acceptance of updated terms.',
    },
    section9: {
      title: '9. Contact',
      intro: 'Questions about these terms:',
    },
  },
  status: {
    pending: 'Pending',
    confirmed: 'Confirmed',
    completed: 'Completed',
    cancelled: 'Cancelled',
  },
  timeSlot: {
    afternoon: 'Afternoon',
    evening: 'Evening',
    night: 'Night',
  },
  imageUploader: {
    invalidType: 'Please select an image file',
    maxSize: 'File size cannot exceed {{size}}MB',
    processingFailed: 'Image processing failed, please try again',
    replace: 'Replace',
    remove: 'Remove',
    reading: 'Reading file...',
    compressing: 'Compressing...',
    dropzone: 'Drag & drop images here or click to browse',
    tapToSelect: 'Tap to select images',
    multipleHint: 'Multiple uploads supported',
    maxSizeHint: 'Max {{size}}MB',
    takePhoto: 'Take Photo',
    preview: 'Preview',
    uploadImage: 'Upload image',
  },
  errors: {
    timeout: 'Request timed out. Please try again.',
    network: 'Network error. Please try again or call us directly.',
    badRequest: 'Please check your input and try again.',
    serverError: 'Our system is temporarily unavailable. Please call us directly.',
  },
  calendarEvent: {
    title: '{{brand}} Party',
    description: 'Hibachi at Home Experience',
    guests: 'Guests',
    region: 'Region',
    bookedBy: 'Booked by',
    time: 'Time',
    chefArrival: 'Our chef will arrive 30 minutes early to set up.',
    contact: 'Contact',
    email: 'Email',
    locationTBD: '{{region}} Area - Address TBD',
  },
  admin: {
    login: {
      title: 'Admin Login',
      subtitle: 'Enter password to continue',
      username: 'Username',
      usernameOptionalPlaceholder: 'Username (leave blank for admin)',
      usernamePlaceholder: 'Enter username',
      password: 'Password',
      passwordPlaceholder: 'Enter password',
      loginButton: 'Login',
      loggingIn: 'Logging in...',
      invalidPassword: 'Invalid password',
      loginFailed: 'Login failed',
      contactHelp: 'Contact for help',
      showPassword: 'Show password',
      hidePassword: 'Hide password',
      registerLink: 'Register as Order Manager',
      registerTitle: 'Register',
      registerSubtitle: 'Create an order manager account',
      displayName: 'Display Name',
      displayNamePlaceholder: 'Enter your name',
      confirmPassword: 'Confirm Password',
      confirmPasswordPlaceholder: 'Re-enter password',
      registerButton: 'Register',
      registering: 'Registering...',
      registerFailed: 'Registration failed',
      registerMissingFields: 'Please fill in all fields',
      passwordMismatch: 'Passwords do not match',
      passwordTooShort: 'Password must be at least 6 characters',
      registerSuccessTitle: 'Registration Submitted',
      registerSuccessMessage:
        'Your account is pending approval. Please wait for an admin to review your registration.',
      backToLogin: 'Back to Login',
      passwordStrength: {
        weak: 'Weak',
        fair: 'Fair',
        good: 'Good',
        strong: 'Strong',
        requirements: 'Use 8+ characters with uppercase, lowercase, and a number',
      },
      errorAccountPending: 'Your account is pending approval by an administrator.',
      errorAccountRejected: 'Your account registration has been rejected.',
      errorAccountDisabled: 'Your account has been disabled. Contact an administrator.',
      errorInvalidCredentials: 'Invalid username or password.',
      errorRateLimited: 'Too many attempts. Please try again later.',
      errorNetwork: 'Unable to connect. Check your internet and try again.',
      needHelp: 'Need help? Contact your administrator',
      registerSuccessBackSoon: 'You will receive access once approved.',
      rememberMe: 'Remember me',
    },
    nav: {
      dashboard: 'Dashboard',
      bookings: 'Bookings',
      calendar: 'Calendar',
      reviews: 'Reviews',
      coupons: 'Coupons',
      gallery: 'Gallery',
      menu: 'Menu',
      instagram: 'Instagram',
      analytics: 'Analytics',
      customers: 'Customers',
      activity: 'Activity',
      settings: 'Settings',
      users: 'Users',
      team: 'Team',
      dispatch: 'Dispatch',
      more: 'More',
    },
    sidebar: {
      overview: 'Overview',
      operations: 'Operations',
      content: 'Content',
      admin: 'Admin',
      expand: 'Expand sidebar',
      collapse: 'Collapse sidebar',
      navigation: 'Admin navigation',
    },
    roles: {
      admin: 'Admin',
      superAdmin: 'Super Admin',
      orderManager: 'Order Manager',
    },
    users: {
      title: 'User Management',
      addUser: 'Add User',
      editUser: 'Edit User',
      deleteUser: 'Delete User',
      username: 'Username',
      usernamePlaceholder: 'Enter username',
      displayName: 'Display Name',
      displayNamePlaceholder: 'Enter display name',
      password: 'Password',
      passwordPlaceholder: 'Enter password',
      confirmPassword: 'Confirm Password',
      newPassword: 'New password (optional)',
      role: 'Role',
      status: 'Status',
      statusApproved: 'Approved',
      statusRejected: 'Rejected',
      enabled: 'Enabled',
      disabled: 'Disabled',
      createdAt: 'Created',
      registeredAt: 'Registered',
      noUsers: 'No users yet. Create one or wait for registrations.',
      deleteConfirm: 'Are you sure you want to delete user "{{name}}"?',
      passwordMismatch: 'Passwords do not match',
      missingFields: 'Please fill in all required fields',
      pendingApproval: 'Pending Approval',
      approve: 'Approve',
      reject: 'Reject',
      edit: 'Edit',
      delete: 'Delete',
      create: 'Create',
      creating: 'Creating...',
      visibility: 'Visibility',
      visibilityFull: 'Full',
      visibilityStandard: 'Standard',
      visibilityMinimal: 'Minimal',
    },
    dashboard: {
      title: 'Dashboard',
      logout: 'Logout',
      refresh: 'Refresh',
      todayBookings: 'Today',
      thisWeek: 'This Week',
      revenue: 'Revenue',
      quickActions: 'Quick Actions',
      sendReminders: 'Send Reminders',
      exportCsv: 'Export CSV',
      viewCalendar: 'View Calendar',
      recentBookings: 'Recent Bookings',
      upcomingBookings: 'Upcoming Bookings',
      next7Days: 'Next 7 days',
      noBookings: 'No bookings found',
      noUpcoming: 'No upcoming bookings in the next 7 days',
      name: 'Name',
      date: 'Date',
      guests: 'Guests',
      status: 'Status',
      region: 'Region',
    },
    stats: {
      totalBookings: 'Total',
      pending: 'Pending',
      confirmed: 'Confirmed',
      completed: 'Completed',
      cancelled: 'Cancelled',
      totalGuests: 'Total Guests',
      todayBookings: 'Today',
      thisWeek: 'This Week',
      revenue: 'Revenue',
    },
    alerts: {
      overduePending: '{{count}} bookings pending for over 24 hours',
      todayUnconfirmed: '{{count}} unconfirmed bookings for today',
      tomorrowReminder: '{{count}} confirmed bookings tomorrow',
      viewBookings: 'View',
    },
    insights: {
      revenueChange: 'Revenue Change',
      weekOverWeek: 'Week over week',
      tomorrowConfirmed: "Tomorrow's Confirmed",
      confirmedBookings: 'Confirmed bookings',
      avgPartySize: 'Avg Party Size',
      thisMonth: 'This month',
      busiestRegion: 'Busiest Region',
      mostBookings: 'Most bookings',
    },
    tabs: {
      all: 'All',
      pending: 'Pending',
      confirmed: 'Confirmed',
      completed: 'Completed',
      cancelled: 'Cancelled',
    },
    booking: {
      noBookings: 'No bookings',
      noBookingsHint: 'Bookings will appear here',
      guests: 'guests',
      booking: 'Booking',
      estimate: 'Estimate',
      contactInfo: 'Contact Info',
      eventDetails: 'Event Details',
      date: 'Date',
      time: 'Time',
      notSpecified: 'Not specified',
      region: 'Region',
      additionalNotes: 'Additional Notes',
      updateStatus: 'Update Status',
      emailCustomer: 'Email Customer',
      callCustomer: 'Call Customer',
      searchPlaceholder: 'Search by name, email, phone, or region...',
      allRegions: 'All Regions',
      from: 'From',
      to: 'To',
      export: 'Export CSV',
      selectAll: 'Select all',
      selectedCount: '{{count}} selected',
      deleteSelected: 'Delete Selected',
      exportSelected: 'Export Selected',
      customer: 'Customer',
      contact: 'Contact',
      dateTime: 'Date & Time',
      guestCount: 'Guests',
      package: 'Package',
      type: 'Type',
      status: 'Status',
      submitted: 'Submitted',
      csvHeaders: {
        name: 'Name',
        email: 'Email',
        phone: 'Phone',
        date: 'Date',
        time: 'Time',
        guests: 'Guests',
        region: 'Region',
        type: 'Type',
        status: 'Status',
        message: 'Message',
        package: 'Package',
        estimatedTotal: 'Estimated Total',
        submitted: 'Submitted',
      },
      actions: 'Actions',
      view: 'View',
      backToList: 'Back to Bookings',
      name: 'Name',
      phone: 'Phone',
      email: 'Email',
      copy: 'Copy',
      copyPhone: 'Copy phone number',
      copyEmail: 'Copy email address',
      smsCustomer: 'SMS',
      orderDetails: 'Order Details',
      guestsAndKids: 'Guests / Kids',
      kids: 'kids',
      serviceType: 'Service',
      minutes: 'min',
      proteins: 'Proteins',
      addons: 'Add-ons',
      estimatedTotal: 'Estimated Total',
      adminNotes: 'Admin Notes',
      adminNotesPlaceholder: 'Add internal notes about this booking...',
      saving: 'Saving...',
      editBooking: 'Edit Booking',
      edit: 'Edit',
      save: 'Save',
      addToGoogleCalendar: 'Add to Google Calendar',
      addToOutlook: 'Add to Outlook',
      downloadICal: 'Download iCal',
      dangerZone: 'Danger Zone',
      deleteWarning: 'This action cannot be undone. The booking will be permanently deleted.',
      deleteBooking: 'Delete Booking',
      deleteConfirmMessage: 'Are you sure you want to delete the booking for {{name}}?',
      batchDeleteConfirmMessage: 'Are you sure you want to delete {{count}} selected bookings?',
      batchStatusConfirmMessage: 'Update {{count}} bookings to "{{status}}"?',
      assignedTo: 'Assigned To',
      assignTo: 'Assign To',
      unassigned: 'Unassigned',
      confirmStatusChange: 'Change status to "{{status}}"?',
      discountInfo: 'Discount Information',
      couponApplied: 'Coupon Applied',
      referralApplied: 'Referral Applied',
      noDiscount: 'No discount applied',
      eventType: 'Event Type',
      orderSnapshot: 'Order snapshot at time of submission (read-only)',
      statusPending: 'Pending',
      statusConfirmed: 'Confirmed',
      statusCompleted: 'Completed',
      statusCancelled: 'Cancelled',
    },
    comments: {
      title: 'Internal Comments',
      placeholder: 'Write a comment...',
      send: 'Send',
      empty: 'No comments yet',
      justNow: 'Just now',
      minutesAgo: '{{count}}m ago',
      hoursAgo: '{{count}}h ago',
      daysAgo: '{{count}}d ago',
    },
    toast: {
      fetchFailed: 'Failed to fetch bookings',
      settingsSaved: 'Settings saved',
      saveFailed: 'Save failed',
      uploadedImages: 'Uploaded {{count}} images',
      imageDeleted: 'Image deleted',
      remindersSent: 'Sent {{count}} reminder emails',
      sendFailed: 'Send failed',
      noDataExport: 'No data to export',
      exported: 'Exported {{count}} records',
      noDataCopy: 'No data to copy',
      copied: 'Copied {{count}} records to clipboard',
      copyFailed: 'Copy failed, please try again',
      browserNotSupported: 'Browser does not support this feature',
      imageGenFailed: 'Failed to generate image',
      imageSaved: 'Image saved ({{count}} records)',
      reviewAdded: 'Review added',
      addFailed: 'Add failed',
      reviewShown: 'Review shown',
      reviewHidden: 'Review hidden',
      operationFailed: 'Operation failed',
      reviewDeleted: 'Review deleted',
      deleteFailed: 'Delete failed',
      accountUpdated: 'Account updated',
      imageMaxSize: 'Image must not exceed 2MB',
      uploadImageAndLink: 'Please upload image and enter link',
      postAdded: 'Post added',
      postDeleted: 'Post deleted',
      enterCouponCode: 'Please enter coupon code',
      couponCreated: 'Coupon created',
      createFailed: 'Create failed',
      couponEnabled: 'Coupon enabled',
      couponDisabled: 'Coupon disabled',
      couponDeleted: 'Coupon deleted',
      statusUpdated: 'Status updated successfully',
      statusUpdatedCount: 'Updated status for {{count}} bookings',
      updateFailed: 'Update failed',
      deleteSuccessful: 'Delete successful',
      deleteSuccessfulCount: 'Deleted {{count}} bookings',
      dateClosed: 'Date closed',
      dateOpened: 'Date opened',
      clipboardCopied: 'Copied',
      userCreated: 'User created',
      userUpdated: 'User updated',
      userDeleted: 'User deleted',
      userApproved: 'User approved',
      userRejected: 'User rejected',
      userEnabled: 'User enabled',
      userDisabled: 'User disabled',
      accessDenied: 'Access denied',
      bookingAssigned: 'Booking assigned',
      visibilityUpdated: 'Visibility updated',
    },
    notifications: {
      title: 'Notifications',
      markAllRead: 'Mark all read',
      empty: 'No notifications',
      bookingAssigned: 'Booking Assigned',
      statusChanged: 'Status Changed',
      bookingCancelled: 'Booking Cancelled',
      reminder: 'Reminder',
      justNow: 'Just now',
      minutesAgo: '{{count}}m ago',
      hoursAgo: '{{count}}h ago',
      daysAgo: '{{count}}d ago',
      unread: 'unread',
    },
    commandPalette: {
      placeholder: 'Search commands, pages, bookings...',
      navigation: 'Navigation',
      actions: 'Actions',
      recentBookings: 'Recent Bookings',
      noResults: 'No results found',
      refresh: 'Refresh Data',
    },
    cancel: 'Cancel',
    confirm: 'Confirm',
    a11y: {
      imagePreview: 'Image preview',
      previousImage: 'Previous image',
      nextImage: 'Next image',
      previousPage: 'Previous page',
      nextPage: 'Next page',
      mobileNavigation: 'Mobile navigation',
      breadcrumb: 'Breadcrumb',
    },
    translatableField: {
      leaveEmptyHint: 'Leave empty to show English',
    },
    team: {
      title: 'Team Overview',
      totalManagers: 'Total Managers',
      unassignedBookings: 'Unassigned Bookings',
      pendingBookings: 'Pending Bookings',
      currentLoad: 'Current Load',
      completedWeek: 'Completed This Week',
      active: 'Active',
      noManagers: 'No order managers found',
      unassignedAlert: '{{count}} bookings are unassigned',
      goToDispatch: 'Go to Dispatch',
      online: 'Online',
      lastSeen: 'Last seen {{time}}',
      neverSeen: 'Never seen',
      workloadDistribution: 'Workload Distribution',
      viewBookings: 'View Bookings',
      reassign: 'Reassign',
    },
    dispatch: {
      title: 'Dispatch Center',
      unassignedQueue: 'Unassigned Queue',
      noUnassigned: 'All bookings are assigned',
      selectManager: 'Select Manager',
      assignSelected: 'Assign Selected ({{count}})',
      assigned: '{{count}} bookings assigned successfully',
      selectBookingsFirst: 'Select bookings to assign',
      recentAssignments: 'Recent Assignments',
      listView: 'List',
      kanbanView: 'Kanban',
      autoAssign: 'Auto-assign',
      assignLeastLoaded: 'Assign to least loaded',
      dragToAssign: 'Drag to assign',
      assignFailed: 'Assignment failed, reverted',
    },
    calendar: {
      loading: 'Loading calendar...',
      prevMonth: 'Previous month',
      nextMonth: 'Next month',
      sun: 'Sun',
      mon: 'Mon',
      tue: 'Tue',
      wed: 'Wed',
      thu: 'Thu',
      fri: 'Fri',
      sat: 'Sat',
      available: 'Available',
      blocked: 'Blocked',
      hasBookings: 'Has bookings',
      bookingsLabel: 'bookings',
      dateBlocked: 'This date is blocked',
      dateAvailable: 'This date is available',
      blockReasonPlaceholder: 'Block reason (optional)',
      blockDate: 'Block this date',
      openDate: 'Open this date',
      processing: 'Processing...',
      bookingsForDate: 'Bookings for this date',
      selectDateHint: 'Select a date to view details',
      blockedDates: 'Blocked Dates',
      noBlockedDates: 'No blocked dates',
      open: 'Open',
      confirmUnblockTitle: 'Unblock Date',
      confirmUnblockMessage: 'Are you sure you want to open this date for bookings?',
      guestsTotal: '{{count}} guests',
      heatLow: '1 booking',
      heatMed: '2-3 bookings',
      heatHigh: '4+ bookings',
    },
    review: {
      loading: 'Loading reviews...',
      addTitle: 'Add New Review',
      customerName: 'Customer Name',
      namePlaceholder: 'e.g. Sarah M.',
      location: 'Location',
      locationPlaceholder: 'e.g. Los Angeles, CA',
      rating: 'Rating',
      eventType: 'Event Type',
      eventPlaceholder: 'e.g. Birthday Party',
      content: 'Review Content',
      contentPlaceholder: 'Customer review content...',
      addButton: 'Add Review',
      adding: 'Adding...',
      listTitle: 'Reviews',
      searchPlaceholder: 'Search by name, content, location...',
      allRatings: 'All Ratings',
      allVisibility: 'All Visibility',
      visibleOnly: 'Visible',
      hiddenOnly: 'Hidden',
      selectedCount: '{{count}} selected',
      showSelected: 'Show Selected',
      hideSelected: 'Hide Selected',
      deleteSelected: 'Delete Selected',
      noReviews: 'No reviews yet',
      selectAll: 'Select all',
      hiddenBadge: 'Hidden',
      edit: 'Edit',
      hide: 'Hide',
      show: 'Show',
      delete: 'Delete',
      save: 'Save',
      saving: 'Saving...',
      confirmDeleteTitle: 'Delete Review',
      confirmDeleteMessage:
        'Are you sure you want to delete this review? This action cannot be undone.',
      confirmBulkDeleteTitle: 'Delete Reviews',
      confirmBulkDeleteMessage: 'Are you sure you want to delete {{count}} selected reviews?',
    },
    coupon: {
      loading: 'Loading coupons...',
      title: 'Coupon Management',
      newCoupon: '+ New Coupon',
      code: 'Coupon Code',
      codePlaceholder: 'e.g. HAPPY10',
      discountType: 'Discount Type',
      percentage: 'Percentage',
      fixedAmount: 'Fixed amount',
      discountValue: 'Discount Value',
      minGuests: 'Min Guests',
      maxUses: 'Max Uses',
      noLimit: '0 = no limit',
      validity: 'Validity',
      to: 'to',
      enabledOnCreate: 'Enabled on creation',
      createButton: 'Create Coupon',
      creating: 'Creating...',
      noCoupons: 'No coupons yet',
      min: 'Min',
      guests: 'guests',
      used: 'Used',
      bookingsUsed: 'bookings used this coupon',
      totalDiscount: 'total discount given',
      expired: 'Expired',
      maxed: 'Maxed',
      active: 'Active',
      disabled: 'Disabled',
      edit: 'Edit',
      duplicate: 'Duplicate',
      enable: 'Enable',
      disable: 'Disable',
      deleteButton: 'Delete',
      save: 'Save',
      saving: 'Saving...',
      confirmDeleteTitle: 'Delete Coupon',
      confirmDeleteMessage:
        'Are you sure you want to delete this coupon? This action cannot be undone.',
      referralTitle: 'Referral Source Stats',
      noReferralData: 'No data yet',
      bookings: 'bookings',
      directVisit: 'Direct visit',
    },
    gallery: {
      title: 'Gallery Management',
      imageCount: '{{count}} images',
      uploadLabel: 'Upload gallery images',
      selectAll: 'Select All',
      deselectAll: 'Deselect All',
      deleteSelected: 'Delete Selected ({{count}})',
      captionPlaceholder: 'Enter caption...',
      moveUp: 'Move up',
      moveDown: 'Move down',
      replace: 'Replace image',
      delete: 'Delete',
      viewFullSize: 'View full size',
      confirmDeleteTitle: 'Delete Image',
      confirmDeleteMessage:
        'Are you sure you want to delete this image? This action cannot be undone.',
      confirmBulkDeleteTitle: 'Delete Images',
      confirmBulkDeleteMessage: 'Are you sure you want to delete {{count}} selected images?',
      uploading: 'Uploading...',
      uploadFailed: 'Failed to upload image',
      searchPlaceholder: 'Search by caption...',
      noImages: 'No images yet',
      noImagesDescription: 'Upload images to build your gallery',
      deletedCount: 'Deleted {{count}} images',
      uploadProgress: 'Uploading {{current}} of {{total}}...',
      urlCopied: 'Image URL copied',
      copyUrl: 'Copy URL',
      captionLimit: '{{current}}/{{max}}',
      noResults: 'No images match your search',
    },
    instagram: {
      title: 'Instagram Management',
      handleLabel: 'Instagram Handle',
      handlePlaceholder: '@yourhandle',
      save: 'Save',
      addPost: 'Add New Post',
      postImage: 'Post Image',
      postLink: 'Post Link',
      linkPlaceholder: 'https://instagram.com/p/...',
      addPostButton: 'Add Post',
      posts: 'Posts',
      selectAll: 'Select All',
      deselectAll: 'Deselect All',
      deleteSelected: 'Delete Selected ({{count}})',
      captionPlaceholder: 'Enter caption...',
      moveUp: 'Move up',
      moveDown: 'Move down',
      delete: 'Delete',
      confirmDeleteTitle: 'Delete Post',
      confirmDeleteMessage:
        'Are you sure you want to delete this post? This action cannot be undone.',
      confirmBulkDeleteTitle: 'Delete Posts',
      confirmBulkDeleteMessage: 'Are you sure you want to delete {{count}} selected posts?',
    },
    settings: {
      timeSlots: 'Available Time Slots',
      addSlot: '+ Add Slot',
      slotNamePlaceholder: 'Slot name',
      newSlotLabel: 'New slot',
      deleteSlot: 'Delete slot',
      confirmDeleteSlotTitle: 'Delete Time Slot',
      confirmDeleteSlotMessage: 'Are you sure you want to delete this time slot?',
      reminders: 'Event Reminder Emails',
      tomorrowEvents: "Tomorrow's events",
      pendingLabel: 'pending',
      noneLabel: 'None',
      remindersSent: 'Reminders sent',
      sending: 'Sending...',
      sendRemindersButton: 'Send Reminder Emails ({{count}})',
      reminderNote: 'Reminder emails are sent to confirmed customers with events tomorrow',
      promoBanner: 'Promo Banner',
      promoEmoji: 'Emoji',
      promoText: 'Promo Text',
      contactInfo: 'Contact Info',
      contactName: 'Contact Name',
      phone: 'Phone',
      email: 'Email',
      featureToggles: 'Feature Toggles',
      features: {
        photoShare: 'Photo Share',
        photoShareDesc: 'Customers share photos for discounts',
        referralProgram: 'Referral Program',
        referralProgramDesc: 'Refer friends and earn rewards',
        newsletter: 'Newsletter',
        newsletterDesc: 'Email subscription feature',
        specialOffer: 'Special Offer Popup',
        specialOfferDesc: 'First visit popup discount',
        instagramFeed: 'Instagram Feed',
        instagramFeedDesc: 'Display Instagram posts',
        coupons: 'Coupon System',
        couponsDesc: 'Use coupons at checkout',
        welcomePopup: 'Welcome Popup',
        welcomePopupDesc: 'First visit welcome modal with value props',
      },
      socialLinks: 'Social Media Links',
      instagramUrl: 'Instagram',
      facebookUrl: 'Facebook',
      tiktokUrl: 'TikTok',
      defaults: {
        brandName: 'Family Friends Hibachi',
        websiteUrl: 'https://familyfriendshibachi.com',
        brandTagline: '#MORESAKEMOREHAPPY',
        promoText: 'Book Today & Get $30 OFF!',
        contactName: 'Family Friends Hibachi Team',
        phone: '909-615-6633',
        email: 'familyfriendshibachi@gmail.com',
        instagramUrl: 'https://instagram.com/familyfriendshibachi',
        facebookUrl: 'https://facebook.com/familyfriendshibachi',
        tiktokUrl: 'https://tiktok.com/@familyfriendshibachi',
        seoTitle: 'Family Friends Hibachi - At Home Hibachi Experience',
        seoDescription: 'Top Rated Hibachi At Home Experience...',
        seoKeywords: 'hibachi, at home hibachi, hibachi catering...',
      },
      dataExport: 'Data Export',
      exportCsv: 'Export CSV',
      copyAllData: 'Copy All Data',
      saveAsImage: 'Save as Image',
      totalBookingsLabel: 'Total {{count}} bookings',
      brandInfo: 'Brand Info',
      brandName: 'Brand Name',
      websiteUrl: 'Website URL',
      brandTagline: 'Brand Tagline',
      logoLabel: 'Brand Logo (square recommended, auto-cropped to 1:1)',
      heroLabel: 'Hero Background (16:9 recommended, auto-cropped)',
      seoSettings: 'SEO Settings',
      pageTitle: 'Page Title',
      seoDescription: 'SEO Description',
      seoKeywords: 'SEO Keywords',
      systemInfo: 'System Info',
      version: 'Version',
      totalBookings: 'Total Bookings',
      blockedDates: 'Blocked Dates',
      enabledSlots: 'Enabled Slots',
    },
    analytics: {
      tabs: {
        revenue: 'Revenue',
        bookings: 'Bookings',
        sources: 'Sources',
        coupons: 'Coupons',
      },
      totalRevenue: 'Total Revenue',
      period: {
        daily: 'Daily',
        weekly: 'Weekly',
        monthly: 'Monthly',
      },
      noData: 'No data available',
      byRegion: 'Bookings by Region',
      byPackage: 'Bookings by Package',
      byStatus: 'Bookings by Status',
      volumeTrend: 'Booking Volume Trend',
      bookingCount: 'Bookings',
      unknown: 'Unknown',
      referralSources: 'Referral Sources',
      directOrUnknown: 'Direct / Unknown',
      usageByCoupon: 'Usage by Coupon',
      noCouponData: 'No coupon usage data',
      timesUsed: 'Times Used',
      revenueImpact: 'Revenue Impact',
      totalDiscountGiven: 'Total Discount Given',
      bookingsWithCoupons: 'Bookings with Coupons',
      activeCoupons: 'Active Coupons',
      last7Days: '7 Days',
      last30Days: '30 Days',
      last90Days: '90 Days',
      thisYear: 'This Year',
      custom: 'Custom',
    },
    customers: {
      title: 'Customer CRM',
      total: 'customers',
      searchPlaceholder: 'Search by name, email, phone...',
      sortLastBooking: 'Last Booking',
      sortTotalBookings: 'Total Bookings',
      sortRevenue: 'Revenue',
      noCustomers: 'No customers yet',
      bookings: 'bookings',
      repeatCustomer: 'Repeat',
      contactInfo: 'Contact Info',
      call: 'Call',
      sms: 'SMS',
      emailAction: 'Email',
      totalBookings: 'Total',
      completed: 'Completed',
      cancelled: 'Cancelled',
      totalRevenue: 'Total Revenue',
      firstBooking: 'First Booking',
      tags: 'Tags',
      addTagPlaceholder: 'Add custom tag...',
      notes: 'Admin Notes',
      saving: 'Saving...',
      notesPlaceholder: 'Add notes about this customer...',
      bookingHistory: 'Booking History',
      tagVip: 'VIP',
      tagCorporate: 'Corporate',
      tagFirstTime: 'First-Time',
    },
    activity: {
      title: 'Activity Log',
      entries: 'entries',
      loading: 'Loading activity log...',
      noEntries: 'No activity recorded yet',
      filterAll: 'All',
      filterBookings: 'Bookings',
      filterCoupons: 'Coupons',
      filterReviews: 'Reviews',
      filterSettings: 'Settings',
    },
    pagination: {
      showing: 'Showing {{start}}-{{end}} of {{total}}',
      prev: 'Prev',
      next: 'Next',
      pageSize: '{{size}} / page',
      jumpTo: 'Go',
      page: 'Page',
    },
    dataTable: {
      noData: 'No data',
      selectAll: 'Select all',
      columns: 'Columns',
      expandRow: 'Expand row',
      collapseRow: 'Collapse row',
    },
    filterBar: {
      search: 'Search...',
      clearAll: 'Clear all',
    },
    errorBoundary: {
      title: 'Something went wrong',
      message: 'An error occurred while loading this section. Please try again.',
      retry: 'Try again',
    },
    error: {
      title: 'Something went wrong',
      description: 'An error occurred while loading this section. Please try again.',
      retry: 'Try again',
    },
    errors: {
      requestTimeout: 'Request timed out. Please try again.',
      networkError: 'Network error. Please check your connection.',
      uploadTimeout: 'Upload timed out. Please try again.',
      unknownError: 'An unknown error occurred.',
      deleteFailed: 'Delete failed. Please try again.',
      permissionDenied: 'You do not have permission to perform this action.',
    },
    time: {
      justNow: 'just now',
      secondsAgo: '{{count}}s ago',
      minutesAgo: '{{count}}m ago',
      hoursAgo: '{{count}}h ago',
      daysAgo: '{{count}}d ago',
    },
    menu: {
      title: 'Menu Management',
      loading: 'Loading menu data...',
      unknownError: 'Unknown error',
      retry: 'Retry',
      failedToLoad: 'Failed to load menu',
      failedToReload: 'Failed to reload',
      saveFailed: 'Save failed',
      resetToDefault: 'Reset to Default',
      resetConfirm:
        'Are you sure you want to reset? All unsaved changes will be lost and data will be reloaded from the server.',
      unsavedChanges: 'You have unsaved changes.',
      discard: 'Discard',
      saving: 'Saving...',
      saveAll: 'Save All Changes',
      tabPackages: 'Packages',
      tabCategories: 'Categories',
      tabItems: 'Items',
      tabSpotlights: 'Spotlight',
      tabPricing: 'Pricing',
      edit: 'Edit',
      delete: 'Delete',
      save: 'Save',
      cancel: 'Cancel',
      visible: 'Visible',
      hidden: 'Hidden',
      untitled: 'Untitled',
      sortOrder: 'Sort Order',
      name: 'Name',
      description: 'Description',
      image: 'Image',
      uploading: 'Uploading...',
      imageUploadFailed: 'Image upload failed',
      packagesCount: 'Packages ({{count}})',
      addPackage: '+ Add Package',
      noPackages: 'No packages yet. Add one to get started.',
      perPerson: '/person',
      guests: 'guests',
      highlighted: 'Highlighted',
      notHighlighted: 'Not Highlighted',
      clickToHide: 'Click to hide',
      clickToShow: 'Click to show',
      removeHighlight: 'Remove highlight',
      addHighlight: 'Add highlight',
      deletePackageConfirm: 'Delete this package?',
      editPackage: 'Edit Package',
      newPackage: 'New Package',
      pricePerPerson: 'Price Per Person ($)',
      minGuests: 'Min Guests',
      maxGuests: 'Max Guests (blank = unlimited)',
      proteinsPerPerson: 'Proteins per person',
      kidsPrice: 'Kids price (blank = global)',
      flatPrice: 'Flat price (blank = per person)',
      serviceDuration: 'Service duration (min)',
      serviceType: 'Service type',
      serviceTypePlaceholder: 'hibachi, buffet, plated...',
      includedCategories: 'Included Categories',
      highlightedFeatured: 'Highlighted (featured)',
      visibleOnSite: 'Visible on site',
      features: 'Features',
      addFeature: '+ Feature',
      featurePlaceholder: 'Feature text',
      categoriesCount: 'Categories ({{count}})',
      addCategory: '+ Add Category',
      noCategories: 'No categories yet.',
      slug: 'Slug',
      deleteCategoryConfirm: 'Delete this category?',
      itemsCount: 'Items ({{count}})',
      addItem: '+ Add Item',
      noItems: 'No items yet.',
      noImage: 'No image',
      available: 'Available',
      unavailable: 'Unavailable',
      deleteItemConfirm: 'Delete this item?',
      editItem: 'Edit Item',
      newItem: 'New Item',
      price: 'Price ($)',
      priceType: 'Price Type',
      priceIncluded: 'Included',
      pricePerPersonItem: 'Per Person',
      pricePerItem: 'Per Item',
      priceUpgrade: 'Upgrade',
      category: 'Category',
      tags: 'Tags (comma-separated)',
      tagsPlaceholder: 'e.g. popular, spicy, vegetarian',
      orderable: 'Orderable',
      spotlightsCount: 'Spotlights ({{count}})',
      addSpotlight: '+ Add Spotlight',
      noSpotlights: 'No spotlights yet.',
      itemLabel: 'Item: {{name}}',
      hasVideo: 'Has Video',
      deleteSpotlightConfirm: 'Delete this spotlight?',
      editSpotlight: 'Edit Spotlight',
      newSpotlight: 'New Spotlight',
      spotlightTitle: 'Title',
      subtitle: 'Subtitle',
      menuItem: 'Menu Item',
      videoUrl: 'Video URL (optional)',
      videoUrlPlaceholder: 'https://youtube.com/...',
      unknownItem: 'Unknown',
      pricingConfig: 'Pricing Configuration',
      kidsPriceLabel: 'Kids Price ($)',
      creditCardFee: 'Credit Card Fee (%)',
      suggestedGratuity: 'Suggested Gratuity (%)',
      cancellationFee: 'Cancellation Fee ($)',
      minimumOrder: 'Minimum Order ($)',
      outdoorNote: 'Outdoor Note',
      weatherNote: 'Weather Note',
      couponTiersCount: 'Coupon Tiers ({{count}})',
      addTier: '+ Add Tier',
      noCouponTiers: 'No coupon tiers configured.',
      guestRange: 'Guest Range',
      guestRangePlaceholder: 'e.g. 10-20 guests',
      discount: 'Discount (%)',
      order: 'Order',
      remove: 'Remove',
      removeTierConfirm: 'Remove this coupon tier?',
    },
    manager: {
      title: 'My Dashboard',
      myBookingsToday: 'My Bookings Today',
      myPending: 'My Pending',
      myCompletedWeek: 'Completed This Week',
      myGuestsWeek: 'Guests This Week',
      todaysTasks: "Today's Tasks",
      noTasksToday: 'No tasks assigned for today',
      upcoming7Days: 'Upcoming 7 Days',
      noUpcoming: 'No upcoming bookings',
      quickActions: 'Quick Actions',
      call: 'Call',
      sms: 'SMS',
      email: 'Email',
    },
    cardView: {
      all: 'All',
      today: 'Today',
      confirm: 'Confirm',
      noBookings: 'No bookings found',
      guests: '{{count}} guests',
    },
    form: {
      required: 'This field is required',
      minLength: 'Minimum {{min}} characters',
      maxLength: 'Maximum {{max}} characters',
      invalidFormat: 'Invalid format',
      draftSaved: 'Draft saved',
      draftRestored: 'Draft restored',
    },
  },
  order: {
    title: 'Build Your Hibachi Experience',
    edit: 'Edit',
    editParty: 'Edit party',
    editCustomize: 'Edit customization',
    minimumGuests: 'Minimum {{count}} guests required',
    adults: 'Adults',
    kids: 'Kids',
    totalGuests: 'Total',
    choosePackage: 'Choose Your Package',
    skipMenu: "Skip — We'll Customize for You",
    regionRequired: 'Please select your region first',
    step1: { label: 'Party', title: 'Party Size & Package' },
    step2: { label: 'Customize', title: 'Customize Your Meal' },
    step3: { label: 'Review', title: 'Review Your Order' },
    step: { bookLabel: 'Book', book: 'Complete Your Booking' },
    review: {
      package: 'Package',
      guests: 'Guests',
      service: 'Service',
      proteins: 'Proteins',
      estimatedTotal: 'Estimated Total',
      addons: 'Add-ons',
      quantity: 'x{{count}}',
    },
    reviewNote: 'No payment required now. We will contact you to confirm details.',
    guestRange: '{{min}}-{{max}} guests required',
    guestMin: '{{min}}+ guests required',
    guestAdjustedTo: 'Guest count adjusted to {{count}}',
    adjustGuests: 'Tap to adjust',
    recovery: {
      title: 'Continue your booking?',
      dateSaved: 'Event date: {{date}}',
      inProgress: 'You have a booking in progress',
      continue: 'Continue',
    },
    back: 'Back',
    increaseAdults: 'Increase adults',
    decreaseAdults: 'Decrease adults',
    increaseKids: 'Increase kids',
    decreaseKids: 'Decrease kids',
    chefsChoice: "Chef's Choice",
    chefsChoiceHint: 'Our chef will select the best seasonal proteins for your party',
    selectProteins: 'Select Your Proteins',
    selectBuffetProteins: 'Select Buffet Proteins',
    addons: 'Sides & Add-ons',
    buildYourOrder: 'Build Your Order',
    progress: 'Order progress',
    estimatedPrice: 'Estimated: ${{amount}}',
    minimumExplanation: '${{minimum}} minimum applies — price will be at least ${{minimum}}',
  },
  welcome: {
    heading: 'Welcome to Family Friends Hibachi!',
    brandLine: '🔥 #1 Rated At-Home Hibachi Experience',
    limitedOffer: 'Limited Time Offer!',
    tagline: 'Premium hibachi brought to your backyard',
    prop1: '$60/Person — All Inclusive',
    prop2: 'No Travel Fee within 50 Miles',
    prop3: 'Free Table & Chair Setup',
    prop4: '10% OFF Weekday Parties',
    urgency: 'Offers valid for new bookings this week only!',
    ctaEstimate: 'Get Free Estimate',
    ctaMenu: 'View Menu',
  },
  floatingContact: {
    call: 'Call',
    text: 'Text',
    email: 'Email',
  },
  exitIntent: {
    title: "Wait! Don't miss out",
    subtitle: 'Get an exclusive discount on your first hibachi party!',
    offerText: 'your first hibachi at home booking',
    emailPlaceholder: 'Enter your email for the coupon',
    claimOffer: 'Claim My $30 Off',
    noSpam: 'No spam — just your coupon code. Unsubscribe anytime.',
    successTitle: 'Coupon on the way!',
    successDesc: 'Check your inbox for your $30 discount code.',
  },
  cityLanding: {
    title: 'Hibachi At Home in {{city}}',
    description:
      'Top rated hibachi at home catering in {{city}}, {{state}}. Professional chefs bring the grill to your backyard starting at ${{price}}/person. Book today!',
    heroTitle: 'Hibachi At Home in {{city}}',
    heroSubtitle:
      'Experience the best at-home hibachi party in {{city}}. Our professional chefs bring the grill, fresh ingredients, and unforgettable entertainment — starting at ${{price}}/person.',
    bookNow: 'Book Now in {{city}}',
    trustRated: '5-Star Rated',
    trustInsured: 'Fully Insured',
    trustEvents: '500+ Events',
    areasTitle: 'Serving All of {{state}}',
    areasSubtitle:
      'We bring the hibachi experience to cities across {{state}}. Select your area below.',
    viewCity: 'View Details',
    nearbyTitle: 'Also Serving Near {{city}}',
    ctaTitle: 'Ready for Hibachi in {{city}}?',
    ctaSubtitle: 'Starting at ${{price}} per person. Book your at-home hibachi experience today!',
  },
};

export default en;
